var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"animated fadeIn"},[_c('genericTable',{attrs:{"table-data":_vm.tableData,"fields":_vm.fields,"per-page":10,"hover":"","striped":"","bordered":"","small":"","caption":"Version List"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }